"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _Stepbox = _interopRequireDefault(require("../Stepbox/Stepbox"));
var BASE_CLASS = 'cic-reset-password-confirmation';
var PasswordForgottenStepThree = function PasswordForgottenStepThree(props) {
  var title = props.title,
    titleText = props.titleText,
    titleSubHeading = props.titleSubHeading,
    stepOneTitle = props.stepOneTitle,
    stepOneDesc = props.stepOneDesc,
    stepTwoTitle = props.stepTwoTitle,
    stepTwoDesc = props.stepTwoDesc,
    stepThreeTitle = props.stepThreeTitle,
    stepThreeDesc = props.stepThreeDesc,
    buttonLabel = props.buttonLabel,
    buttonVersion = props.buttonVersion,
    handleGoToLogin = props.handleGoToLogin;
  var steps = [{
    name: 'Schritt',
    title: stepOneTitle,
    desc: stepOneDesc,
    active: false,
    success: true,
    icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
      size: "54",
      glyph: "icon_mail-2_54x54"
    })
  }, {
    name: 'Schritt',
    title: stepTwoTitle,
    desc: stepTwoDesc,
    active: false,
    success: true,
    icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
      size: "54",
      glyph: "icon_password_54x54"
    })
  }, {
    name: 'Schritt',
    title: stepThreeTitle,
    desc: stepThreeDesc,
    active: true,
    success: false,
    icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
      size: "54",
      glyph: "icon_user-2_54x54"
    }),
    button: {
      text: buttonLabel,
      version: buttonVersion,
      onClick: handleGoToLogin
    }
  }];
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 text-center"
  }, /*#__PURE__*/_react.default.createElement("h2", null, title), /*#__PURE__*/_react.default.createElement("p", null, titleText), /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(BASE_CLASS, "__subheading")
  }, titleSubHeading)), /*#__PURE__*/_react.default.createElement(_Stepbox.default, {
    baseClass: "register-confirmation",
    steps: steps
  }));
};
PasswordForgottenStepThree.propTypes = {
  title: _propTypes.default.string.isRequired,
  titleText: _propTypes.default.string.isRequired,
  titleSubHeading: _propTypes.default.string.isRequired,
  stepOneTitle: _propTypes.default.string,
  stepOneDesc: _propTypes.default.string,
  stepTwoTitle: _propTypes.default.string,
  stepTwoDesc: _propTypes.default.string,
  stepThreeTitle: _propTypes.default.string,
  stepThreeDesc: _propTypes.default.string,
  buttonLabel: _propTypes.default.string,
  buttonVersion: _propTypes.default.string,
  handleGoToLogin: _propTypes.default.func
};
var _default = exports.default = PasswordForgottenStepThree;